import axios from 'axios';

export interface CropTypeNode {
  _id: string;
  code: string;
  name: string;
  parentCode: string | null;
  order: number;
}

export async function listGlobalCropTypes(): Promise<CropTypeNode[]> {
  const res = await axios.get('/api/v1/global-crop-types', { withCredentials: true });
  return res.data as CropTypeNode[];
}
